import React from 'react';
import {useSortable} from '@dnd-kit/sortable';
import {CSS} from '@dnd-kit/utilities';
import { useViewMode } from '../contexts/ViewModeContext';

/**
 * Simple wrapper component to make any element sortable
 * Children should be the track JSX from AnnotationSheet
 */
export default function SortableTrack({id, children}) {
  const {isViewMode, isTrackEditMode} = useViewMode();
  const disabled = isViewMode || !isTrackEditMode || id === 'music-structure-track' || id === 'chord-track';
  const {attributes, listeners, setNodeRef, transform, transition} = useSortable({id});
  const style = {
    transform: disabled ? undefined : CSS.Transform.toString(transform),
    transition: disabled ? 'none' : transition,
  };

  return (
    <div
      ref={setNodeRef}
      style={{
        ...style,
        cursor: 'inherit', // lets children (like resize handles) set their own cursor
      }}
      {...(!disabled && attributes)}
      {...(!disabled && listeners)}
    >
      {children}
    </div>
  );
}
